import { Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AssignmentIcon from "@mui/icons-material/Assignment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InventoryIcon from "@mui/icons-material/Inventory";
import PendingIcon from "@mui/icons-material/Pending";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";
import DefaultApiService from "../../../../infrastructure/api/default";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import BarChartCustom from "../../../components/shared/chart/BarChartCustom";
import PieChartCustom from "../../../components/shared/chart/PieChartCustom";

const SupplierDashboardPage = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({
    totalContracts: 0,
    activeContracts: 0,
    completedContracts: 0,
    pendingContracts: 0,
    activePackages: 0,
    totalRevenue: 0,
    activeRevenue: 0,
  });
  const [contractStatusData, setContractStatusData] = useState([]);
  const [monthlyContractsData, setMonthlyContractsData] = useState([]);
  const [monthlyRevenueData, setMonthlyRevenueData] = useState([]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        
        // دریافت آمار کلان از API
        const statsRes = await DefaultApiService.getApi("SLN/Supplier/SupplierDashboard/GetStatistics", {}, true);
        if (statsRes?.isSuccess && statsRes?.data) {
          setStats({
            totalContracts: statsRes.data.totalContracts || 0,
            activeContracts: statsRes.data.activeContracts || 0,
            completedContracts: statsRes.data.completedContracts || 0,
            pendingContracts: statsRes.data.pendingContracts || 0,
            activePackages: statsRes.data.activePackages || 0,
            totalRevenue: statsRes.data.totalRevenue || 0,
            activeRevenue: statsRes.data.activeRevenue || 0,
          });
        }

        // دریافت داده‌های نمودار وضعیت قراردادها
        const statusChartRes = await DefaultApiService.getApi("SLN/Supplier/SupplierDashboard/GetContractStatusChart", {}, true);
        if (statusChartRes?.isSuccess && statusChartRes?.data && statusChartRes.data.length > 0) {
          const formattedStatusData = (statusChartRes.data || []).map(item => ({
            name: item.statusName,
            value: item.count
          }));
          setContractStatusData(formattedStatusData);
        } else {
          // داده‌های فیک برای نمودار وضعیت قراردادها
          const fakeStatusData = [
            { name: "در حال انجام", value: 35 },
            { name: "تکمیل شده", value: 28 },
            { name: "در انتظار تایید", value: 12 },
            { name: "تایید شده توسط سولارنت", value: 8 },
            { name: "رد شده", value: 5 },
          ];
          setContractStatusData(fakeStatusData);
        }

        // دریافت داده‌های نمودار ماهانه قراردادها
        const monthlyChartRes = await DefaultApiService.getApi("SLN/Supplier/SupplierDashboard/GetMonthlyContractsChart", {}, true);
        if (monthlyChartRes?.isSuccess && monthlyChartRes?.data && monthlyChartRes.data.length > 0) {
          const formattedMonthlyData = (monthlyChartRes.data || []).map(item => ({
            MonthName: `${item.monthName} ${item.year}`,
            تعداد: item.count
          }));
          setMonthlyContractsData(formattedMonthlyData);
        } else {
          // داده‌های فیک برای نمودار ماهانه قراردادها
          const fakeMonthlyData = [
            { MonthName: "فروردین 1403", تعداد: 8 },
            { MonthName: "اردیبهشت 1403", تعداد: 12 },
            { MonthName: "خرداد 1403", تعداد: 15 },
            { MonthName: "تیر 1403", تعداد: 18 },
            { MonthName: "مرداد 1403", تعداد: 22 },
            { MonthName: "شهریور 1403", تعداد: 19 },
            { MonthName: "مهر 1403", تعداد: 25 },
            { MonthName: "آبان 1403", تعداد: 28 },
            { MonthName: "آذر 1403", تعداد: 24 },
            { MonthName: "دی 1403", تعداد: 30 },
            { MonthName: "بهمن 1403", تعداد: 32 },
            { MonthName: "اسفند 1403", تعداد: 35 },
          ];
          setMonthlyContractsData(fakeMonthlyData);
        }

        // دریافت داده‌های نمودار درآمد ماهانه
        const revenueChartRes = await DefaultApiService.getApi("SLN/Supplier/SupplierDashboard/GetMonthlyRevenueChart", {}, true);
        if (revenueChartRes?.isSuccess && revenueChartRes?.data && revenueChartRes.data.length > 0) {
          const formattedRevenueData = (revenueChartRes.data || []).map(item => ({
            MonthName: `${item.monthName} ${item.year}`,
            درآمد: item.revenue
          }));
          setMonthlyRevenueData(formattedRevenueData);
        } else {
          // داده‌های فیک برای نمودار درآمد ماهانه
          const fakeRevenueData = [
            { MonthName: "فروردین 1403", درآمد: 125000000 },
            { MonthName: "اردیبهشت 1403", درآمد: 185000000 },
            { MonthName: "خرداد 1403", درآمد: 220000000 },
            { MonthName: "تیر 1403", درآمد: 275000000 },
            { MonthName: "مرداد 1403", درآمد: 320000000 },
            { MonthName: "شهریور 1403", درآمد: 290000000 },
            { MonthName: "مهر 1403", درآمد: 380000000 },
            { MonthName: "آبان 1403", درآمد: 425000000 },
            { MonthName: "آذر 1403", درآمد: 365000000 },
            { MonthName: "دی 1403", درآمد: 450000000 },
            { MonthName: "بهمن 1403", درآمد: 480000000 },
            { MonthName: "اسفند 1403", درآمد: 520000000 },
          ];
          setMonthlyRevenueData(fakeRevenueData);
        }
        
        setLoading(false);
      } catch (error) {
        console.error("خطا در دریافت داده‌های داشبورد:", error);
        // در صورت خطا، داده‌های فیک را نمایش می‌دهیم
        const fakeStatusData = [
          { name: "در حال انجام", value: 35 },
          { name: "تکمیل شده", value: 28 },
          { name: "در انتظار تایید", value: 12 },
          { name: "تایید شده توسط سولارنت", value: 8 },
          { name: "رد شده", value: 5 },
        ];
        const fakeMonthlyData = [
          { MonthName: "فروردین 1403", تعداد: 8 },
          { MonthName: "اردیبهشت 1403", تعداد: 12 },
          { MonthName: "خرداد 1403", تعداد: 15 },
          { MonthName: "تیر 1403", تعداد: 18 },
          { MonthName: "مرداد 1403", تعداد: 22 },
          { MonthName: "شهریور 1403", تعداد: 19 },
          { MonthName: "مهر 1403", تعداد: 25 },
          { MonthName: "آبان 1403", تعداد: 28 },
          { MonthName: "آذر 1403", تعداد: 24 },
          { MonthName: "دی 1403", تعداد: 30 },
          { MonthName: "بهمن 1403", تعداد: 32 },
          { MonthName: "اسفند 1403", تعداد: 35 },
        ];
        const fakeRevenueData = [
          { MonthName: "فروردین 1403", درآمد: 125000000 },
          { MonthName: "اردیبهشت 1403", درآمد: 185000000 },
          { MonthName: "خرداد 1403", درآمد: 220000000 },
          { MonthName: "تیر 1403", درآمد: 275000000 },
          { MonthName: "مرداد 1403", درآمد: 320000000 },
          { MonthName: "شهریور 1403", درآمد: 290000000 },
          { MonthName: "مهر 1403", درآمد: 380000000 },
          { MonthName: "آبان 1403", درآمد: 425000000 },
          { MonthName: "آذر 1403", درآمد: 365000000 },
          { MonthName: "دی 1403", درآمد: 450000000 },
          { MonthName: "بهمن 1403", درآمد: 480000000 },
          { MonthName: "اسفند 1403", درآمد: 520000000 },
        ];
        setContractStatusData(fakeStatusData);
        setMonthlyContractsData(fakeMonthlyData);
        setMonthlyRevenueData(fakeRevenueData);
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  // کارت‌های آماری اصلی
  const statCards = [
    {
      title: "کل قراردادها",
      value: stats.totalContracts.toLocaleString("fa-IR"),
      sub: "قرارداد ثبت شده",
      color: "#1976d2",
      icon: <AssignmentIcon />,
    },
    {
      title: "قراردادهای فعال",
      value: stats.activeContracts.toLocaleString("fa-IR"),
      sub: "در حال انجام",
      color: "#2e7d32",
      icon: <PlayArrowIcon />,
    },
    {
      title: "قراردادهای تکمیل شده",
      value: stats.completedContracts.toLocaleString("fa-IR"),
      sub: "پایان یافته",
      color: "#ed6c02",
      icon: <CheckCircleIcon />,
    },
    {
      title: "در انتظار تایید",
      value: stats.pendingContracts.toLocaleString("fa-IR"),
      sub: "قرارداد در انتظار",
      color: "#9c27b0",
      icon: <PendingIcon />,
    },
    {
      title: "پکیج‌های فعال",
      value: stats.activePackages.toLocaleString("fa-IR"),
      sub: "پکیج موجود",
      color: "#d32f2f",
      icon: <InventoryIcon />,
    },
    {
      title: "درآمد کل",
      value: `${stats.totalRevenue.toLocaleString("fa-IR")} ریال`,
      sub: "از قراردادهای تکمیل شده",
      color: "#2e7d32",
      icon: <AttachMoneyIcon />,
    },
    {
      title: "درآمد در حال انجام",
      value: `${stats.activeRevenue.toLocaleString("fa-IR")} ریال`,
      sub: "از قراردادهای فعال",
      color: "#1976d2",
      icon: <ShoppingCartIcon />,
    },
  ];

  return (
    <Box
      sx={{
        px: { xs: 1, md: 2 },
        py: { xs: 1, md: 1.5 },
        background: "#F6F8FB",
      }}
    >
      {/* نوار بالای داشبورد */}
      <Box sx={{ mb: 1.5 }}>
        <BreadcrumbsComponent />
        <Typography variant="h5" fontWeight={700} sx={{ mt: 1 }}>
          داشبورد تامین‌کننده تجهیزات
        </Typography>
      </Box>

      {/* کارت‌های آمار */}
      <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
        {statCards.map((card, idx) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={idx >= 5 ? 4 : idx >= 3 ? 3 : 3}
            key={idx}
          >
            <Card 
              sx={{ 
                borderRadius: 3, 
                boxShadow: 1,
                transition: "all 0.3s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 3,
                },
              }}
            >
              <CardContent sx={{ py: 1.5, px: 2, "&:last-child": { pb: 1.5 } }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                  <Avatar
                    sx={{ bgcolor: card.color, mr: 1, width: 36, height: 36 }}
                  >
                    {card.icon}
                  </Avatar>
                  <Typography fontWeight={700} fontSize={14}>
                    {card.title}
                  </Typography>
                </Box>
                <Typography fontWeight={700} fontSize={20} color={card.color}>
                  {card.value}
                </Typography>
                <Typography fontSize={13} color="text.secondary">
                  {card.sub}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* نمودارها */}
      <Grid container spacing={1.5}>
        {/* نمودار وضعیت قراردادها */}
        <Grid item xs={12} md={4}>
          <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
            <CardHeader
              title="وضعیت قراردادها"
              sx={{ pb: 0, pt: 1.5, px: 2 }}
              titleTypographyProps={{ fontSize: 15, fontWeight: 600 }}
            />
            <CardContent sx={{ py: 1, px: 2 }}>
              <Box sx={{ height: 350 }}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography>در حال بارگذاری...</Typography>
                  </Box>
                ) : contractStatusData.length > 0 ? (
                  <PieChartCustom
                    title="توزیع قراردادها بر اساس وضعیت"
                    data={contractStatusData}
                    series={["تعداد"]}
                    xAxis="StatusName"
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      داده‌ای برای نمایش وجود ندارد
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* نمودار میله‌ای ماهانه قراردادها */}
        <Grid item xs={12} md={8}>
          <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
            <CardHeader
              title="نمودار ماهانه قراردادها"
              sx={{ pb: 0, pt: 1.5, px: 2 }}
              titleTypographyProps={{ fontSize: 15, fontWeight: 600 }}
            />
            <CardContent sx={{ py: 1, px: 2 }}>
              <Box sx={{ height: 350 }}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography>در حال بارگذاری...</Typography>
                  </Box>
                ) : monthlyContractsData.length > 0 ? (
                  <BarChartCustom
                    title="تعداد قراردادهای ثبت شده به تفکیک ماه"
                    xAxis="MonthName"
                    xAxisTitle="ماه"
                    yAxisTitle="تعداد قرارداد"
                    data={monthlyContractsData}
                    series={["تعداد"]}
                    colors={["#1976d2"]}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      داده‌ای برای نمایش وجود ندارد
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* نمودار درآمد ماهانه */}
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
            <CardHeader
              title="نمودار درآمد ماهانه"
              sx={{ pb: 0, pt: 1.5, px: 2 }}
              titleTypographyProps={{ fontSize: 15, fontWeight: 600 }}
            />
            <CardContent sx={{ py: 1, px: 2 }}>
              <Box sx={{ height: 400 }}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography>در حال بارگذاری...</Typography>
                  </Box>
                ) : monthlyRevenueData.length > 0 ? (
                  <BarChartCustom
                    title="درآمد از قراردادهای تکمیل شده به تفکیک ماه"
                    xAxis="MonthName"
                    xAxisTitle="ماه"
                    yAxisTitle="درآمد (ریال)"
                    data={monthlyRevenueData}
                    series={["درآمد"]}
                    colors={["#2e7d32"]}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      داده‌ای برای نمایش وجود ندارد
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SupplierDashboardPage;
